import { useUpdateOrgMfaDisabled } from "@/apiQueries/useUpdateOrgMfaDisabled";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardWithToggler } from "./CardWithToggler";

export const SettingsDisableMfa = () => {
  const { organization } = useRedux("organization");
  const { isChecked, isPending, error, handleToggleChange } = useSettingsToggle({
    currentValue: Boolean(organization.data.mfa_disabled),
    useUpdateMutation: useUpdateOrgMfaDisabled,
    getNextValue: (current) => !current,
  });

  return (
    <CardWithToggler
      toggleId="mfa-disabled"
      label="Disable Multi-Factor Authentication (MFA)"
      note="Toggle this option to disable Multi-Factor Authentication for user logins. When disabled, users will not need to enter a verification code and this organization will use the platform default setting."
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    />
  );
};
